import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { authTypeOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { CONFIGURATION, SAML } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-saml-sso-configuration',
  templateUrl: './saml-sso-configuration.component.html',
  styleUrls: ['./saml-sso-configuration.component.scss']
})
export class SamlSsoConfigurationComponent implements OnInit {

  @Input() public Content: any;

  authForm: UntypedFormGroup;
  authTypeList: any;
  FILE_NAME :string = "";
  fileToUpload: File | null;
  LDAPString:string = 'LDAP://';
  IsSSLChecked:boolean = false;
  IsPasswordProtected: boolean = false;

  constructor(
    private summaryService: AdministrationSummaryService,
    private modalService : NgbModal,
    private appFunctions: AppFunctionsService,
    private commonService: CommonService,
    public modalRef: NgbActiveModal,
    public Clipboard: Clipboard
  ) {
    this.authForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      AUTH_NAME : new UntypedFormControl("",[Validators.required,Validators.maxLength(100)]),
      AUTH_TYPE_CODE : new UntypedFormControl({value:"SAML",disabled:true},[Validators.required]),
      ORG_CODE : new UntypedFormControl("",[Validators.required,Validators.maxLength(100)]),
      STATUS : new UntypedFormControl(true),
      SAML_IDP_SIGNIN_URL : new UntypedFormControl("",[Validators.required,Validators.maxLength(3000)]),
      SAML_IDP_ISSUER_URL : new UntypedFormControl("",[Validators.required,Validators.maxLength(200)]),
      SAML_IS_VER_CERT_FILE_UPLOADED : new UntypedFormControl("0"),
      VER_CERT : new UntypedFormControl("",[Validators.required,Validators.maxLength(2000)]),
      SAML_IS_PWD_PROTECTED : new UntypedFormControl(false),
      SAML_VER_CERT_PWD : new UntypedFormControl({value:"",disabled: true},[Validators.required,Validators.maxLength(100)]),
      SAML_IS_SIGNED_AUTH_REQUEST : new UntypedFormControl(false),
      SAML_IS_SIGNED_RESPONSE : new UntypedFormControl(false),
      SAML_IS_ENCRYPTED_ASSERTION : new UntypedFormControl(false),
      SAML_IS_SIGNED_ASSERTION : new UntypedFormControl(false),
      SAML_LOGIN_URL : new UntypedFormControl(serviceConstants.baseUrl,[Validators.required,Validators.maxLength(200)]),
      SAML_ACS_URL : new UntypedFormControl(serviceConstants.apiURL + "api/Samlsso/AssertionConsumerService",[Validators.required,Validators.maxLength(200)]),
      LDAP_SERVER_NAME : new UntypedFormControl("",[Validators.required,Validators.maxLength(100)]),
      LDAP_SERVER_ALIAS_NAME : new UntypedFormControl(""),
      LDAP_PORT_NUMBER : new UntypedFormControl("389"),
      LDAP_USER_DN : new UntypedFormControl("",[Validators.required,Validators.maxLength(100)]),
      LDAP_IS_SSL : new UntypedFormControl(false),
      CERT_FILE_STORE_ID : new UntypedFormControl(""),
      FILE_NAME : new UntypedFormControl(""),
      CERT_TEXT_STORE_ID: new UntypedFormControl("")
    });
   }

  ngOnInit() {
    this.authTypeList = this.Content.content.authTypeList;

    if(this.Content.heading == "Edit" || this.Content.heading == "View"){
        this.getAuthById();
    }
     if (this.Content.heading === "View") {
        this.authForm.disable();
    }

  }

  save(){
    if(this.validateControls()){
      let apiURL = "api/configuration/";
      if(this.Content.heading == "Add"){
        apiURL += 'insert'
      }
      else if(this.Content.heading == "Edit"){
        apiURL += 'update'
      }

      if(this.authForm.controls["SAML_IS_VER_CERT_FILE_UPLOADED"].value == "0"){
        this.authForm.controls["SAML_IS_VER_CERT_FILE_UPLOADED"].setValue(false); 
      }
      else{
        this.authForm.controls["SAML_IS_VER_CERT_FILE_UPLOADED"].setValue(true); 
      }

      this.authForm.controls["SAML_LOGIN_URL"].setValue(this.authForm.controls['SAML_LOGIN_URL'].value + '/' + this.authForm.controls['ORG_CODE'].value + '/login');
      this.authForm.controls["SAML_ACS_URL"].setValue(this.authForm.controls['SAML_ACS_URL'].value + '?orgCode=' + this.authForm.controls['ORG_CODE'].value + '&authName=' + this.authForm.controls['AUTH_NAME'].value);

      this.summaryService.PostData(apiURL,this.authForm.getRawValue()).subscribe((res)=>{
        if(res!=null && res!= undefined){
          if(res.Status == 0){
            this.modalRef.close();
            this.commonService.SuccessBanner(res.Message);
          }
          else if (res.ErrorCode == "NOCHANGES"){
            this.authForm.controls["SAML_LOGIN_URL"].setValue(serviceConstants.baseUrl);
            this.authForm.controls["SAML_ACS_URL"].setValue(serviceConstants.apiURL + "api/Samlsso/AssertionConsumerService");
      
            if(this.authForm.controls["SAML_IS_VER_CERT_FILE_UPLOADED"].value == false){
              this.authForm.controls["SAML_IS_VER_CERT_FILE_UPLOADED"].setValue("0");
            }
            else{
              this.authForm.controls["SAML_IS_VER_CERT_FILE_UPLOADED"].setValue("1");
            }

            this.commonService.ValidationBanner(res.Message);
          }
          else{
            this.commonService.ValidationBanner(res.Message);
          }
        }
      })

    }
  }

  validateControls(): boolean {
    let isValid:boolean = true;
    let isAuthTypeValid:boolean = true;

    let err:string = "";

    let trimmedAuthName : string = this.authForm.controls["AUTH_NAME"].value.trim();

    if(trimmedAuthName == "" || trimmedAuthName == undefined){
      isValid = false;
      err += ("Please enter Authentication Name <br/>");
    }

    let trimmedOrgCode : string = this.authForm.controls["ORG_CODE"].value.trim();

    if(trimmedOrgCode == "" || trimmedOrgCode == undefined){
      isValid = false;
      err += ("Please enter Org Code <br/>");
    }

    if(this.authForm.controls["AUTH_TYPE_CODE"].value == ""){
      isAuthTypeValid = false;
      err += ("Please select Authentication Type <br/>");
    }

    if(!isAuthTypeValid){
      this.commonService.ValidationBanner(err);
      return isAuthTypeValid;
    }

    if(this.authForm.controls["AUTH_TYPE_CODE"].value == "SAML"){
      let trimmedSignInURL:string = this.authForm.controls["SAML_IDP_SIGNIN_URL"].value.trim();

      if(trimmedSignInURL == "" || trimmedSignInURL == undefined){
        isValid = false;
        err += ("Please enter Sign-In URL <br/>");
      }

      let trimmedIssuer:string = this.authForm.controls["SAML_IDP_ISSUER_URL"].value.trim();
      if(trimmedIssuer == "" || trimmedIssuer == undefined){
        isValid = false;
        err += ("Please enter Issuer <br/>");
      }

      let isFileUpload:string = this.authForm.controls["SAML_IS_VER_CERT_FILE_UPLOADED"].value;
      let trimmedVerCert :string = this.authForm.controls["VER_CERT"].value?.trim();
      if(isFileUpload == "0" && (trimmedVerCert == "" || trimmedVerCert == undefined)){
        isValid = false;
        err += ("Please enter Verification Certificate <br/>");
      }
      else if(isFileUpload == "1"){
        if(this.authForm.controls["CERT_FILE_STORE_ID"].value == null || this.authForm.controls["CERT_FILE_STORE_ID"].value == "" || this.authForm.controls["CERT_FILE_STORE_ID"].value == undefined){
          isValid = false;
          err += ("Please upload Verification Certificate<br/>");
        }

        let trimmedPasswordProtected = this.authForm.controls["SAML_VER_CERT_PWD"].value?.trim();
        if(this.IsPasswordProtected && (trimmedPasswordProtected == "" || trimmedPasswordProtected == undefined)){
          isValid = false;
          err += ("Please enter Password Protected? <br/>");
        }

      }

      let trimmedloginUrl:string = this.authForm.controls["SAML_LOGIN_URL"].value.trim();
      if(trimmedloginUrl == "" || trimmedloginUrl == undefined){
        isValid = false;
        err += ("Please enter Login URL <br/>");
      }

    }
    else if(this.authForm.controls["AUTH_TYPE_CODE"].value == "LDAP"){
      let trimmedServerName : string = this.authForm.controls["LDAP_SERVER_NAME"].value.trim();
      if(trimmedServerName == "" || trimmedServerName == undefined){
        isValid = false;
        err += ("Please enter Server Name <br/>");
      }
      
      let trimmedUserDN :string = this.authForm.controls["LDAP_USER_DN"].value.trim();
      if(trimmedUserDN == "" || trimmedUserDN == undefined){
        isValid = false;
        err +=  ("Please enter User DN <br/>");
      }
    }


    if (!(trimmedOrgCode === null || trimmedOrgCode === "" || trimmedOrgCode === undefined))
         {
          if (trimmedOrgCode.trim().length < 4 ) {
            $("#NAME").addClass("ng-touched ng-invalid validate-error");
            $("#NAME").removeClass("ng-untouched ng-valid");
            err += "Org Code must have at least 4 characters <br/>";
            isValid = false;
          }
        }

    if(!isValid){
      this.commonService.ValidationBanner(err);
      return isValid;
    }

    return isValid;
  }

  handleFile(event: any){
    debugger;
    let IsnotCer = false;
    let files = event?.target?.files;
    if (files.length > 0) {
      this.fileToUpload = files.item(0);
      let file = this.fileToUpload.name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = this.fileToUpload.size;

      if (file != null && (ext != 'json')) {
        IsnotCer = true;        
      }
      if (IsnotCer) {
        this.commonService.ValidationBanner("Please ensure you upload a valid JSON file format.");
         return false;
      }
  
      let fileId: string | undefined = 'null';
      fileId = this.authForm.controls["ID"].value;

      if (this.fileToUpload) {
        this.summaryService.uploadFile(this.fileToUpload,fileId).subscribe({
          next: ((result) => {
            if (result.Status == 0){
              this.FILE_NAME = this.fileToUpload.name;
              this.authForm.controls["CERT_FILE_STORE_ID"].setValue(result.Data);
            }
          }),
          error: ((err) => {

          })
        });
      }
      else{
        this.authForm.controls["CERT_FILE_STORE_ID"].setValue(null);
      }
    }
  }

  downloadPublicKey() {
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/DownloadCertificatefile";
    window.open(Url,"_blank");

  }

  copyUrl(controlName:string) {
    let url = "";
    if(controlName == 'SAML_LOGIN_URL'){
        url =  this.authForm.controls['SAML_LOGIN_URL'].value + '/' + this.authForm.controls['ORG_CODE'].value + '/login';
    }
    else if(controlName == 'SAML_ACS_URL'){
       url = this.authForm.controls['SAML_ACS_URL'].value + '?orgCode=' + this.authForm.controls['ORG_CODE'].value + '&authName=' + this.authForm.controls['AUTH_NAME'].value;
    }
    if (url != "") {
      this.Clipboard.copy(url);
    }
  }

  isSSLChecked(){
    
    this.IsSSLChecked = this.authForm.controls["LDAP_IS_SSL"].value;

    if(this.IsSSLChecked){
      this.authForm.controls["LDAP_PORT_NUMBER"].setValue("636");
      this.LDAPString = 'LDAPS://';
      this.IsSSLChecked = true;
    }
    else{
      this.authForm.controls["LDAP_PORT_NUMBER"].setValue("389");
      this.LDAPString = 'LDAP://';
      this.IsSSLChecked = false;
    }
  }

  getAuthById(){
    this.summaryService.getConfiguration('api/configuration/getauthbyid?AuthId='+ this.Content.content.RecordData.ID).subscribe((res)=>{
      if(res!=null && res!= undefined){
        if(res.SAML_IS_VER_CERT_FILE_UPLOADED){
          res.SAML_IS_VER_CERT_FILE_UPLOADED = "1"
        }
        else{
          res.SAML_IS_VER_CERT_FILE_UPLOADED = "0"
        }
          this.authForm.patchValue(res);

          this.authForm.controls["SAML_LOGIN_URL"].setValue(serviceConstants.baseUrl);
          this.authForm.controls["SAML_ACS_URL"].setValue(serviceConstants.apiURL + "api/Samlsso/AssertionConsumerService");
          this.FILE_NAME = res.FILE_NAME;

          this.authForm.controls["AUTH_NAME"].disable();
      }
    })
  }

}
